module.exports = __webpack_public_path__ + "78b77168bf4a0467efec1acf110ea618.png";